var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useIwaContext } from "@cognitranlimited/itis-web";
import { useState } from "react";
var APNKey = "APN";
var DFCKey = "DFC";
export var HIDDEN_FIELDS = [APNKey, DFCKey];
export var useForm = function (_a) {
    var productVariantData = _a.productVariantData, closeTab = _a.closeTab, document = _a.document;
    var iwaContext = useIwaContext();
    var _b = useState({}), selectedOptions = _b[0], setSelectedOptions = _b[1];
    var groupedUniqueValuesFiltered = groupByAllUnique(productVariantData, selectedOptions);
    var getFieldOptions = function (key) {
        return getOptionsForField(productVariantData, selectedOptions, key).map(function (option) { return [option, option]; });
    };
    var handleSelectChange = function (title_value, value) {
        setSelectedOptions(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[title_value] = value, _a)));
        });
    };
    var submit = function () {
        var outstandingAPNs = getOptionsForField(productVariantData, selectedOptions, APNKey);
        var outstandingDFCs = getOptionsForField(productVariantData, selectedOptions, DFCKey);
        var groupId = new URLSearchParams(window.location.search).get('group');
        iwaContext.navigate(iwaContext.navigation.document(__assign(__assign({}, document), { groupId: groupId }), {
            parameters: "apn=".concat(outstandingAPNs.join(","), "&familyCode=").concat(outstandingDFCs[0].toString()),
        }));
        closeTab();
    };
    return {
        selectedOptions: selectedOptions,
        fieldsToDisplay: Object.keys(groupedUniqueValuesFiltered),
        handleSelectChange: handleSelectChange,
        getFieldOptions: getFieldOptions,
        submit: submit,
    };
};
/**
 * Given an array of items and an optional filter, returns
 * an object mapping each key to an array of all unique values
 * in that key.
 *
 * @param items - The data array.
 * @param filter - An optional filter object.
 * @returns An object with unique values for each key in `items`.
 */
function groupByAllUnique(items, filter) {
    var result = {};
    var filteredItems = filter
        ? items.filter(function (item) {
            return Object.entries(filter).every(function (_a) {
                var key = _a[0], value = _a[1];
                return value === "" || item[key] === value;
            });
        })
        : items;
    filteredItems.forEach(function (item) {
        Object.keys(item).forEach(function (key) {
            if (!result[key]) {
                result[key] = new Set();
            }
            result[key].add(item[key]);
        });
    });
    var uniqueResult = {};
    Object.keys(result).forEach(function (key) {
        uniqueResult[key] = Array.from(result[key]);
    });
    return uniqueResult;
}
/**
 * Gets unique options for a specific field by applying filters
 * on the other fields only. This allows the target field's options
 * to be independent of its current selection.
 *
 * @param items - The data array.
 * @param currentFilter - The complete current filter.
 * @param targetField - The field we're generating options for.
 * @returns A unique array of options for the targetField.
 */
function getOptionsForField(items, currentFilter, targetField) {
    var relaxedFilter = Object.keys(currentFilter).reduce(function (acc, key) {
        if (key !== targetField) {
            acc[key] = currentFilter[key];
        }
        return acc;
    }, {});
    var uniqueOptions = groupByAllUnique(items, relaxedFilter);
    return uniqueOptions[targetField] || [];
}
